<template>
    <div :style="{'height': clientHeight-70+'px'}" style="overflow: auto;">
        <div class="m-portlet m-portlet--creative m-portlet--bordered-semi" style="margin: 30px auto">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h2 class="m-portlet__head-label m-portlet__head-label--primary"
                            style="width: 100px;text-align: center;">
                            <span>{{student.name}}</span>
                        </h2>
                    </div>
                </div>
            </div>

            <div class="m-portlet__body m-portlet__body--small-padding">

                <el-form ref="form" label-width="120px" label-position="center">
                    <el-form-item>
                        <el-button @click="handleSave()">保存</el-button>
                    </el-form-item>
                </el-form>
                <el-tabs tab-position="left" style="height: 2000px">
                    <el-tab-pane label="基础信息">
                        <el-form ref="form" label-width="120px" label-position="center">
                            <el-divider content-position="left">基础信息</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="爱好">
                                        <el-select
                                                style="width: 372.5px"
                                                v-model="student.hobbies"
                                                multiple
                                                filterable
                                                allow-create
                                                default-first-option
                                                placeholder="请选择">
                                        </el-select>

                                    </el-form-item>


                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="QQ">
                                        <el-input v-model="student.qq"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="电话">
                                        <el-input v-model="student.phone"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="家庭背景">
                        <el-form ref="form" label-width="120px" label-position="center">
                            <el-divider content-position="left">家庭背景</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>
                            <el-form-item
                                    v-for="(socialRelation, index) in file.socialRelations"
                                    :label="'社会关系' + index"
                            >
                                <el-row>
                                    <el-col :span="20">
                                        <el-input v-model="socialRelation.value"></el-input>

                                    </el-col>
                                    <el-col :span="4">
                                        <el-button @click.prevent="remove(socialRelation)">删除</el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item>

                            <el-form-item>
                                <el-button @click="add">新增社会关系</el-button>
                            </el-form-item>


                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="父亲姓名">
                                        {{father.name}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="父亲手机号">
                                        {{father.phone}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="父亲职业">
                                        <el-input v-model="file.fatherOccupation"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="母亲姓名">
                                        {{mother.name}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="母亲手机号">
                                        {{mother.phone}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="母亲职业">
                                        <el-input v-model="file.motherOccupation"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="其他描述">
                                        <el-input v-model="file.otherDescription"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="家庭住址">
                                        <el-input v-model="file.homeAddress"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="家庭经济状况">
                                        <el-radio-group v-model="file.familyEconomicSituation">
                                            <el-radio label="殷实"></el-radio>
                                            <el-radio label="中等"></el-radio>
                                            <el-radio label="困难"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="经济状态详细">
                                        <el-input v-model="file.detailedFamilyEconomicStatus"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="班主任印象">

                        <el-form ref="form" label-width="120px" label-position="center">

                            <el-divider content-position="left">班主任印象</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="学习态度">
                                        <el-radio-group v-model="file.learningAttitude">
                                            <el-radio label="端正"></el-radio>
                                            <el-radio label="一般"></el-radio>
                                            <el-radio label="轻浮"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="聪慧程度">
                                        <el-radio-group v-model="file.intelligenceLevel">
                                            <el-radio label="聪明"></el-radio>
                                            <el-radio label="一般"></el-radio>
                                            <el-radio label="不理想"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="班主任熟悉程度">
                                        <el-radio-group v-model="file.familiarityOfHeadTeachers">
                                            <el-radio label="很熟"></el-radio>
                                            <el-radio label="中等"></el-radio>
                                            <el-radio label="不熟"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="墨帝教育">
                        <el-form ref="form" label-width="120px" label-position="center">
                            <el-divider content-position="left">墨帝成绩记录</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>
                            <vxe-button @click="insertEvent('modiExam',examExample)">插入</vxe-button>

                            <vxe-table
                                    ref="modiExam"
                                    border
                                    class="xtable" resizable
                                    :data="modiExam"
                                    :edit-config="{trigger: 'click', mode: 'row'}"
                                    @edit-actived="editActivedEvent('modiExam')"

                                    @edit-closed="editClosedEvent">
                                <vxe-table-column type="index" width="60"></vxe-table-column>
                                <vxe-table-column field="exam" title="考试" width="150px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="all" title="总分" width="100px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="ranking" title="总分排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="chinese" title="语文" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="chineseRanking" title="语文排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="math" title="数学" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="mathRanking" title="数学排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="english" title="英语" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="englishRanking" title="英语排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="physics" title="物理" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="physicsRanking" title="物理排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="chemistry" title="化学" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="chemistryRanking" title="化学排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="history" title="历史" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="historyRanking" title="历史排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="politics" title="政治" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="politicsRanking" title="政治排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="biology" title="生物" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="biologyRanking" title="生物排名" width="200px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>

                            </vxe-table>
                            <el-divider content-position="left">墨帝班主任回访记录</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>
                            <div style="height: 500px">
                                <el-table
                                    :data="returnVisit"
                                    height="500"
                                    size="middle"
                                    style="width: 100%">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <el-form label-position="left" inline class="demo-table-expand" label-width="120px">
                                            <el-form-item label="家长反馈">
                                                <span>{{ props.row.return_visit_opinion }}</span>
                                            </el-form-item>
                                            <el-form-item label="家长建议">
                                                <span>{{ props.row.attributeOpinion }}</span>
                                            </el-form-item>
                                            <el-form-item label="卖课反馈">
                                                <span>{{ props.row.sellClassFeedback }}</span>
                                            </el-form-item>
                                            <el-form-item label="回访备注">
                                                <span>{{ props.row.remark }}</span>
                                            </el-form-item>
                                        </el-form>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="回访时间"
                                        prop="return_date">
                                </el-table-column>
                                <el-table-column
                                        label="拨号人"
                                        prop="headTeacher_name">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.headTeacher_name">{{scope.row.headTeacher_name}}</span>
                                        <span v-else>数据缺失</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="被回访人">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.parent_name"> 家长：{{scope.row.parent_name}}</span>
                                        <span v-else> 学生：{{$parentInfo.student.name}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="开始回访时间"
                                        prop="created_at">
                                </el-table-column>
                                <el-table-column
                                        label="回访时长"
                                        prop="return_time">
                                </el-table-column>
                            </el-table>
                            </div>


                            <el-divider content-position="left">盘老师情况</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>
                            <div style="height: 500px">
                                <el-table
                                        :data="returnTeacher"
                                        height="500"
                                        size="middle"
                                        style="width: 100%">
                                    <el-table-column
                                            prop="date"
                                            label="教师反馈时间"
                                            width="150">
                                    </el-table-column>
                                    <el-table-column
                                            prop="class_name"
                                            label="课程"
                                            width="100">
                                    </el-table-column>
                                    <el-table-column
                                            prop="teacher_name"
                                            label="老师"
                                            width="80">
                                    </el-table-column>
                                    <el-table-column
                                            prop="serious_degree"
                                            label="上课投入程度"
                                            width="150">
                                    </el-table-column>
                                    <el-table-column
                                            prop="note_degree"
                                            label="笔记记录"
                                            width="130">
                                    </el-table-column>
                                    <el-table-column
                                            prop="review_degree"
                                            label="回家复习消化"
                                            width="130">
                                    </el-table-column>
                                    <el-table-column
                                            prop="content"
                                            label="反馈内容">
                                    </el-table-column>
                                </el-table>
                            </div>



                            <el-divider content-position="left">介绍人数</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="家长转介绍人数">
                                        {{file.parentReferrals}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="学生转介绍人数">
                                        {{file.studentReferrals}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="家庭教育">
                        <el-form ref="form" label-width="120px" label-position="center">

                            <el-divider content-position="left">家庭教育</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="负责家长">
                                        <el-radio-group v-model="file.mainGuardian">
                                            <el-radio label="爸"></el-radio>
                                            <el-radio label="妈"></el-radio>
                                            <el-radio label="爸妈"></el-radio>
                                            <el-radio label="没人管"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="家庭重视程度">
                                        <el-radio-group v-model="file.familyAttention">
                                            <el-radio label="很关心"></el-radio>
                                            <el-radio label="中等"></el-radio>
                                            <el-radio label="不关心"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>

                    </el-tab-pane>
                    <el-tab-pane label="校外教育">
                        <el-form ref="form" label-width="120px" label-position="center">

                            <el-divider content-position="left">校外教育</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>
                            <vxe-button @click="insertEvent('extensionEducation',{
                                        organization:'',
                                        appraise:''
                                   })">插入
                            </vxe-button>

                            <vxe-table
                                    ref="extensionEducation"
                                    border
                                    class="xtable" resizable
                                    :data="extensionEducation"
                                    :edit-config="{trigger: 'click', mode: 'row'}"
                                    @edit-actived="editActivedEvent('extensionEducation')"
                                    @edit-closed="editClosedEvent">
                                <vxe-table-column type="index" width="60"></vxe-table-column>
                                <vxe-table-column field="organization" title="曾补课机构" width="300px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>
                                <vxe-table-column field="appraise" title="评价" width="500px"
                                                  :edit-render="{name: 'input'}"></vxe-table-column>

                            </vxe-table>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="校内教育">
                        <el-form ref="form" label-width="120px" label-position="center">

                            <el-divider content-position="left">校内教育</el-divider>
                            <div class="m-separator m-separator--space m-separator--dashed"></div>

                            <el-form-item label="小学" label-width="50px">
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="学校">
                                            <el-select
                                                    v-model="educationalExperiences['small'].school_id"
                                                    align="right"
                                                    placeholder="学校"
                                                    style="width:200px">
                                                <el-option
                                                        v-for="item in schools"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="班级">
                                            <el-select
                                                    v-model="educationalExperiences['small'].schoolClass_id"
                                                    align="right"
                                                    placeholder="班级"
                                                    style="width:200px">
                                                <el-option
                                                        v-for="item in schoolClasses"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="目标院校">
                                            <el-input v-model="file.smallGoal"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-form-item label="校内教师">
                                    <vxe-button @click="insertEvent('smallSchoolTeacher',{
                                        teacher:'',
                                        subject:'',
                                        situation:'',
                                        appraise:''
                                   })">插入
                                    </vxe-button>

                                    <vxe-table
                                            ref="smallSchoolTeacher"
                                            border
                                            class="xtable"
                                            resizable
                                            :data="smallSchoolTeacher"
                                            :edit-config="{trigger: 'click', mode: 'row'}"
                                            @edit-actived="editActivedEvent('smallSchoolTeacher')"
                                            @edit-closed="editClosedEvent">

                                        <vxe-table-column type="index" width="60"></vxe-table-column>
                                        <vxe-table-column field="teacher" title="任课老师" width="150px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="subject" title="科目" width="100px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="situation" title="任课老师情况" width="300px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="任课老师评价" width="350px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>

                                    </vxe-table>
                                </el-form-item>

                                <el-form-item label="校内成绩记录">
                                    <vxe-button @click="insertEvent('smallSchoolExam',examExample)">插入</vxe-button>

                                    <vxe-table
                                            ref="smallSchoolExam"
                                            border
                                            class="xtable" resizable
                                            :data="smallSchoolExam"
                                            :edit-config="{trigger: 'click', mode: 'row'}"
                                            @edit-actived="editActivedEvent('smallSchoolExam')"

                                            @edit-closed="editClosedEvent">
                                        <vxe-table-column type="index" width="60"></vxe-table-column>
                                        <vxe-table-column field="exam" title="考试" width="150px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="all" title="总分" width="100px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="ranking" title="总分排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chinese" title="语文" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chineseRanking" title="语文排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="math" title="数学" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="mathRanking" title="数学排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="english" title="英语" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="englishRanking" title="英语排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="physics" title="物理" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="physicsRanking" title="物理排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chemistry" title="化学" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chemistryRanking" title="化学排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="history" title="历史" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="historyRanking" title="历史排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="politics" title="政治" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="politicsRanking" title="政治排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="biology" title="生物" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="biologyRanking" title="生物排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>

                                    </vxe-table>

                                </el-form-item>
                            </el-form-item>
                            <el-form-item label="初中" label-width="50px">
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="学校">
                                            <el-select
                                                    v-model="educationalExperiences['middle'].school_id"
                                                    align="right"
                                                    placeholder="学校"
                                                    style="width:200px">
                                                <el-option
                                                        v-for="item in schools"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="班级">
                                            <el-select
                                                    v-model="educationalExperiences['middle'].schoolClass_id"
                                                    align="right"
                                                    placeholder="班级"
                                                    style="width:200px">
                                                <el-option
                                                        v-for="item in schoolClasses"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="目标院校">
                                            <el-input v-model="file.middleGoal"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="校内教师">
                                    <vxe-button @click="insertEvent('middleSchoolTeacher',{
                                        teacher:'',
                                        subject:'',
                                        situation:'',
                                        appraise:''
                                   })">插入
                                    </vxe-button>

                                    <vxe-table
                                            ref="middleSchoolTeacher"
                                            border
                                            class="xtable" resizable
                                            :data="middleSchoolTeacher"
                                            :edit-config="{trigger: 'click', mode: 'row'}"
                                            @edit-actived="editActivedEvent('middleSchoolTeacher')"

                                            @edit-closed="editClosedEvent">
                                        <vxe-table-column type="index" width="60"></vxe-table-column>
                                        <vxe-table-column field="organization" title="任课老师" width="150px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="科目" width="100px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="任课老师情况" width="300px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="任课老师评价" width="350px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>

                                    </vxe-table>
                                </el-form-item>

                                <el-form-item label="校内成绩记录">
                                    <vxe-button @click="insertEvent('middleSchoolExam',examExample)">插入</vxe-button>

                                    <vxe-table
                                            ref="middleSchoolExam"
                                            border
                                            class="xtable" resizable
                                            :data="middleSchoolExam"
                                            :edit-config="{trigger: 'click', mode: 'row'}"
                                            @edit-actived="editActivedEvent('middleSchoolExam')"
                                            @edit-closed="editClosedEvent">
                                        <vxe-table-column type="index" width="60"></vxe-table-column>
                                        <vxe-table-column field="exam" title="考试" width="150px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="all" title="总分" width="100px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="ranking" title="总分排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chinese" title="语文" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chineseRanking" title="语文排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="math" title="数学" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="mathRanking" title="数学排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="english" title="英语" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="englishRanking" title="英语排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="physics" title="物理" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="physicsRanking" title="物理排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chemistry" title="化学" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chemistryRanking" title="化学排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="history" title="历史" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="historyRanking" title="历史排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="politics" title="政治" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="politicsRanking" title="政治排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="biology" title="生物" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="biologyRanking" title="生物排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>

                                    </vxe-table>

                                </el-form-item>
                            </el-form-item>
                            <el-form-item label="高中" label-width="50px">
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="学校">
                                            <el-select
                                                    v-model="educationalExperiences['high'].school_id"
                                                    align="right"
                                                    placeholder="学校"
                                                    style="width:200px">
                                                <el-option
                                                        v-for="item in schools"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="班级">
                                            <el-select
                                                    v-model="educationalExperiences['high'].schoolClass_id"
                                                    align="right"
                                                    placeholder="班级"
                                                    style="width:200px">
                                                <el-option
                                                        v-for="item in schoolClasses"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="目标院校">
                                            <el-input v-model="file.highGoal"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="校内教师">
                                    <vxe-button @click="insertEvent('highSchoolTeacher',{
                                        teacher:'',
                                        subject:'',
                                        situation:'',
                                        appraise:''
                                   })">插入
                                    </vxe-button>

                                    <vxe-table
                                            ref="highSchoolTeacher"
                                            border
                                            class="xtable" resizable
                                            :data="highSchoolTeacher"
                                            :edit-config="{trigger: 'click', mode: 'row'}"
                                            @edit-actived="editActivedEvent('highSchoolTeacher')"
                                            @edit-closed="editClosedEvent">
                                        <vxe-table-column type="index" width="60"></vxe-table-column>
                                        <vxe-table-column field="organization" title="任课老师" width="150px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="科目" width="100px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="任课老师情况" width="300px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="appraise" title="任课老师评价" width="350px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>

                                    </vxe-table>
                                </el-form-item>

                                <el-form-item label="校内成绩记录">
                                    <vxe-button @click="insertEvent('highSchoolExam',examExample)">插入</vxe-button>

                                    <vxe-table
                                            ref="highSchoolExam"
                                            border
                                            class="xtable" resizable
                                            :data="highSchoolExam"
                                            :edit-config="{trigger: 'click', mode: 'row'}"
                                            @edit-actived="editActivedEvent('highSchoolExam')"
                                            @edit-closed="editClosedEvent">
                                        <vxe-table-column type="index" width="60"></vxe-table-column>
                                        <vxe-table-column field="exam" title="考试" width="150px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="all" title="总分" width="100px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="ranking" title="总分排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chinese" title="语文" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chineseRanking" title="语文排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="math" title="数学" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="mathRanking" title="数学排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="english" title="英语" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="englishRanking" title="英语排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="physics" title="物理" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="physicsRanking" title="物理排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chemistry" title="化学" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="chemistryRanking" title="化学排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="history" title="历史" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="historyRanking" title="历史排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="politics" title="政治" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="politicsRanking" title="政治排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="biology" title="生物" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="biologyRanking" title="生物排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="geography" title="地理" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                        <vxe-table-column field="geographyRanking" title="地理排名" width="200px"
                                                          :edit-render="{name: 'input'}"></vxe-table-column>
                                    </vxe-table>
                                </el-form-item>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>

                <el-form ref="form" label-width="120px" label-position="center">
                    <el-form-item>
                        <el-button @click="handleSave()">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                activeTable: '',
                examExample: {
                    exam: null,
                    all: null,
                    ranking: null,
                    chinese: null,
                    chineseRanking: null,
                    math: null,
                    mathRanking: null,
                    english: null,
                    englishRanking: null,
                    physics: null,
                    physicsRanking: null,
                    chemistry: null,
                    chemistryRanking: null,
                    history: null,
                    historyRanking: null,
                    politics: null,
                    politicsRanking: null,
                    biology: null,
                    biologyRanking: null,
                    geography:null,
                    geographyRanking:null
                },
                path: '/student/file/' + this.$route.params.id,
                student: {
                    id: 0,
                    birthday: '',
                    current_education: {
                        grade: {
                            id: 0,
                            name: '',
                        },
                        school: {
                            id: 0,
                            name: '',
                        },
                        schoolClass: {
                            id: 0,
                            name: '',
                        },
                    },
                    gender_id: 0,
                    headTeacher_id: [],
                    name: '',
                    parents: [],
                    phone: 0,
                    qq: '',
                    referrer_name: '',
                    referrer_type: '',
                    star: '',
                    subjects: [],
                    wechat: [],
                },
                parents: {},
                father: {
                    name: "",
                    phone: ""
                },
                mother: {
                    name: "",
                    phone: ""
                },
                file: {
                    detailedFamilyEconomicStatus: null,
                    familiarityOfHeadTeachers: null,
                    familyAttention: null,
                    familyEconomicSituation: null,
                    fatherOccupation: null,
                    homeAddress: null,
                    intelligenceLevel: null,
                    learningAttitude: null,
                    mainGuardian: null,
                    motherOccupation: null,
                    otherDescription: null,
                    parentReferrals: null,
                    studentReferrals: null,
                    student_id: 1329,
                    socialRelations: [
                        {
                            value: '',
                            key: Date.now()
                        }
                    ]
                },
                tableData: [],
                schoolClasses: [],
                schools: [],
                educationalExperiences: {
                    small: {
                        grade_id: null,
                        graduated_at: null,
                        schoolClass_id: null,
                        school_id: null,
                        school_type: "small",
                        school_year: null
                    },
                    middle: {
                        grade_id: null,
                        graduated_at: null,
                        schoolClass_id: null,
                        school_id: null,
                        school_type: "middle",
                        school_year: null
                    },
                    high: {
                        grade_id: null,
                        graduated_at: null,
                        schoolClass_id: null,
                        school_id: null,
                        school_type: "high",
                        school_year: null
                    }
                },

                extensionEducation: [],
                modiExam: [],
                smallSchoolTeacher: [],
                middleSchoolTeacher: [],
                highSchoolTeacher: [],
                smallSchoolExam: [],
                middleSchoolExam: [],
                highSchoolExam: [],
                returnTeacher: [],
                returnVisit: []
            }
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight;
            },
        },
        created() {
            this.$wApi.addListen(this.path, this.handleData);
            this.handleShowStudent();
        },
        methods: {

            handleSave() {
                this.$wApi.send(this.path, 'storeFile', {
                    'student_id': this.$route.params.id,
                    'file': this.file,
                    'student': this.student,
                    'father': this.father,
                    'mother': this.mother,
                    'modiExam': this.modiExam,
                    'smallSchoolTeacher': this.smallSchoolTeacher,
                    'middleSchoolTeacher': this.middleSchoolTeacher,
                    'highSchoolTeacher': this.highSchoolTeacher,
                    'smallSchoolExam': this.smallSchoolExam,
                    'middleSchoolExam': this.middleSchoolExam,
                    'highSchoolExam': this.highSchoolExam,
                    'extensionEducation': this.extensionEducation,
                    'returnTeacher': this.returnTeacher,
                    'returnVisit': this.returnVisit,
                    'educationalExperiences': this.educationalExperiences
                });
            },
            handleShowStudent() {
                this.student_id = this.$route.params.id;
                this.$wApi.send(this.path, 'getFile', {
                    'student_id': this.$route.params.id
                });
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'getFile':
                        this.student = data.student;
                        this.file = data.file;
                        this.schoolClasses = data.schoolClasses;
                        this.schools = data.schools;

                        if (data.parents.hasOwnProperty('父亲')) {
                            this.father = data.parents['父亲']
                        }
                        if (data.parents.hasOwnProperty('母亲')) {
                            this.mother = data.parents['母亲']
                        }

                        if (data.educationalExperiences.small != null) {
                            this.educationalExperiences.small = data.educationalExperiences.small;
                        }
                        if (data.educationalExperiences.middle != null) {
                            this.educationalExperiences.middle = data.educationalExperiences.middle;
                        }
                        if (data.educationalExperiences.high != null) {
                            this.educationalExperiences.high = data.educationalExperiences.high;
                        }

                        this.extensionEducation = data.file.extensionEducation,
                            this.modiExam = data.file.modiExam,
                            this.smallSchoolTeacher = data.file.smallSchoolTeacher,
                            this.middleSchoolTeacher = data.file.middleSchoolTeacher,
                            this.highSchoolTeacher = data.file.highSchoolTeacher,
                            this.smallSchoolExam = data.file.smallSchoolExam,
                            this.middleSchoolExam = data.file.middleSchoolExam,
                            this.highSchoolExam = data.file.highSchoolExam,
                            this.returnTeacher = data.file.returnTeacher,
                            this.returnVisit = data.file.returnVisit

                        break;
                    case 'storeFile':
                        this.$message('保存成功');
                        break;
                }
            },
            remove(item) {
                var index = this.file.socialRelations.indexOf(item)
                if (index !== -1) {
                    this.file.socialRelations.splice(index, 1)
                }
            },
            add() {
                this.file.socialRelations.push({
                    value: '',
                    key: Date.now()
                });
            },
            editActivedEvent(ref) {
                this.activeTable = ref
            },
            editClosedEvent({row, column}, event) {

                if (this.$data[this.activeTable]==null){
                    this.$data[this.activeTable]=[];
                }

                this.$data[this.activeTable].push(row);

                let arr= this._.uniq(this.$data[this.activeTable]);

                this.$data[this.activeTable]=arr;

            },
            insertEvent(ref, example) {
                this.$refs[ref].insertAt(example, -1)
            },
        }
    }
</script>

<style scoped>
    .xtable {
        margin-bottom: 20px;
    }
</style>
